<form [formGroup]="assetForm"
      class="flex flex-col w-full"
      (ngSubmit)="onFormSubmit()"
      [appEnterKeySubmit]="assetForm"
      [onSubmit]="onSubmit.bind(this)"
>
  <h2 class="text-center text-xl mb-4">{{title}}</h2>
  <tandem-form-input class="w-full"
                     [autoFocus]="true"
                     [form]="assetForm"
                     [label]="assetDetails?.alternateNameLabel || 'Name'"
                     [inputId]="'name'"
                     [controlName]="'name'"
                     [placeholder]="assetDetails?.alternateNameLabel || 'Name'"
                     [isDisabled]="true"
                     [tooltipText]="assetDetails?.alternateNameHint || defaultName"></tandem-form-input>
  <tandem-form-input class="w-full"
                     [form]="assetForm"
                     [label]="assetDetails?.alternateValueLabel || 'Value'"
                     [inputId]="'value'"
                     [controlName]="'value'"
                     [placeholder]="assetDetails?.alternateValueLabel || 'Value'"
                     [inputType]="'number'"
                     [prefixText]="'$'"
                     [maskType]="'currency'"
                     [tooltipText]="assetDetails?.alternateValueHint || defaultValue"></tandem-form-input>
  <tandem-form-input class="w-full"
                     [form]="assetForm"
                     [label]="assetDetails?.alternateAPRLabel || 'Annual Percentage Return (%)'"
                     [inputId]="'annualPercentageReturn'"
                     [controlName]="'annualPercentageReturn'"
                     [placeholder]="assetDetails?.alternateAPRLabel || 'Annual Percentage Return (%)'"
                     [inputType]="'number'"
                     [tooltipText]="assetDetails?.alternateAPRHint || defaultAPR"
                     prefixText="%"
                     [maskType]="'percent'"
  ></tandem-form-input>
  <div class="flex flex-col md:flex-row w-full justify-start md:justify-between md:gap-x-4">
    <tandem-form-input *ngIf="assetForm.get('liquidityUnits')?.value !== 'Instant'"
                       class="w-full"
                       [form]="assetForm"
                       [label]="assetDetails?.alternateLiquidityLabel || 'Liquidity'"
                       [inputId]="'liquidityQuantity'"
                       [controlName]="'liquidityQuantity'"
                       [placeholder]="assetDetails?.alternateLiquidityLabel || 'Liquidity'"
                       [inputType]="'number'"
                       maskType="number"
                       [tooltipText]="assetDetails?.alternateLiquidityHint || defaultLiquidity"></tandem-form-input>
    <tandem-form-select [form]="assetForm"
                        class="w-full"
                        [label]="assetForm.get('liquidityUnits')?.value == 'Instant' ? assetDetails?.alternateLiquidityLabel || 'Liquidity' : 'Timeframe'"
                        [inputId]="'liquidityUnits'"
                        [controlName]="'liquidityUnits'"
                        [options]="LIQUIDITY_OPTIONS"></tandem-form-select>
  </div>
  <tandem-form-input class="w-full"
                     [form]="assetForm"
                     [label]="assetDetails?.alternateExpensesLabel || 'Associated Expenses'"
                     [inputId]="'associatedExpenses'"
                     [controlName]="'associatedExpenses'"
                     [placeholder]="assetDetails?.alternateExpensesLabel || 'Associated Expenses'"
                     [tooltipText]="assetDetails?.alternateExpensesHint || defaultExpenses"></tandem-form-input>
  <div class="flex flex-row w-full justify-center gap-15 mt-10 gap-x-4">
    <tandem-button color="white" [onClick]="onCancel.bind(this)">{{mode === 'view' ? 'Close' : 'Cancel'}}</tandem-button>
    <tandem-button *ngIf="mode !== 'view'" type="submit" theme="solid" [onClick]="onSubmit.bind(this)" [disabled]="assetForm.invalid">Save</tandem-button>
  </div>
</form>
